export * from "./contexts";
export * from "./dates";
export * from "./promises";
export * from "./types";
export const safeSetLocalStorage = (key, value) => {
  try {
    localStorage.setItem(key, value);
  } catch {}
};
export function safeJsonParse(value) {
  try {
    return value ? JSON.parse(value) : {};
  } catch {
    return {};
  }
}
export function notEmpty(value) {
  return !(value === undefined || value === null || value === "" || value === "0" || value === 0 || value === false || typeof value === "object" && Object.keys(value).length === 0);
}
export function unionArray(...arrays) {
  const set = new Set();
  return [...arrays].flat().filter(key => set.has(key) ? false : set.add(key));
}
export function getWindow() {
  return typeof window === "undefined" ? null : window;
}

/**
 * As theme.breakpoints.up("desktop") will return @media (min-width:1024px), we need to remove the @media manually
 */
export function removeAtMedia(breakpointString) {
  return breakpointString.replaceAll("@media", "").trim();
}
export function findFirstNonEmptyString(...values) {
  var _values$find$trim, _values$find;
  return (_values$find$trim = (_values$find = values.find(value => {
    var _value$length;
    return (_value$length = value === null || value === void 0 ? void 0 : value.length) !== null && _value$length !== void 0 ? _value$length : 0 > 0;
  })) === null || _values$find === void 0 ? void 0 : _values$find.trim()) !== null && _values$find$trim !== void 0 ? _values$find$trim : "";
}
const webViewRegex = new RegExp("(" + ["WebView", "(iPhone|iPod|iPad)(?!.*Safari)", "Android.*(;\\s+wv|Version/\\d.\\d\\s+Chrome/\\d+(\\.0){3})", "Linux; U; Android"].join("|") + ")", "ig");
export function checkIsInWebView() {
  if (typeof window === "undefined") return false;
  return webViewRegex.test(window.navigator.userAgent);
}